import { createStore } from 'jotai';

export const store = createStore();

export * from './location.state';
